var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { audiDarkTheme, audiLightTheme, AudiPlatformProvider, } from '@audi/audi-ui-react';
import React from 'react';
const withAudiDesignSystem = (theme) => (Component) => {
    const WithAudiDesignSystem = (_a) => {
        var props = __rest(_a, []);
        return (React.createElement(AudiPlatformProvider, { theme: theme },
            React.createElement(Component, Object.assign({}, props))));
    };
    WithAudiDesignSystem.displayName = `WithAudiDesignSystem(${Component.displayName || Component.name || 'Component'})`;
    return WithAudiDesignSystem;
};
export const withAudiDesignSystemDark = withAudiDesignSystem(audiDarkTheme);
export const withAudiDesignSystemLight = withAudiDesignSystem(audiLightTheme);
